/**
 * Deps da era Next esperam `process` no bundle do browser.
 *
 * Nasceu pelo next-auth, que saiu com o BFF de autenticação — mas o shim fica:
 * outras dependências ainda leem `process.env.NODE_ENV`. O que saiu foi a
 * entrada `NEXTAUTH_URL`, que só o next-auth consumia.
 */
if (typeof globalThis.process === 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ;(globalThis as any).process = {
    env: {
      NODE_ENV: import.meta.env.MODE
    }
  }
}
